import { render } from "./Detalji.vue?vue&type=template&id=4a9d2fb4"
import script from "./Detalji.vue?vue&type=script&lang=js"
export * from "./Detalji.vue?vue&type=script&lang=js"

import "./Detalji.vue?vue&type=style&index=0&id=4a9d2fb4&lang=css"
import "./Detalji.vue?vue&type=style&index=1&id=4a9d2fb4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__